import { useState, useEffect } from 'react';
import { theme } from '../theme';

export function useWidth() {

  const [width, setWindowWidth] = useState(window.innerWidth)   
  
  useEffect(() => {

    updateDimensions();

    window.addEventListener('resize', updateDimensions);     
    return () => window.removeEventListener('resize',updateDimensions);

  }, []);

  const updateDimensions = () => {
     setWindowWidth(window.innerWidth)
   }

   return width;
};

export function useIsMobile() {
  return handleResize(useWidth(), theme.deviceValues.mobile)
}

export function useIsTablet() {
  return handleResize(useWidth(), theme.deviceValues.tablet)
}

const handleResize = (width: number, deviceValue: number) => {
  if (width < deviceValue) {
      return true
  } else {
      return false
  }
}